export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-36 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 md:gap-12">
          <div className="col-span-12 md:col-span-4 mb-4 md:mb-0">
            <div className="flex items-center gap-3 mb-6">
              <span className="font-mono text-[10px] tracking-[0.28em] uppercase text-zinc-500">
                01 / About
              </span>
              <span className="flex-1 h-px bg-white/10" />
            </div>
            <h3 className="font-heading text-2xl md:text-3xl tracking-tight font-medium text-white leading-tight">
              A research-driven technology company.
            </h3>
          </div>

          <div className="col-span-12 md:col-span-8">
            <p
              data-testid="about-lead"
              className="font-heading text-3xl md:text-4xl lg:text-[44px] leading-[1.15] tracking-tight text-white font-medium"
            >
              Noeton Labs is an early-stage Canadian R&amp;D company building
              strong technical foundations at the intersection of{" "}
              <span className="text-zinc-500">applied mathematics</span>,{" "}
              <span className="text-zinc-500">computation</span>, and{" "}
              <span className="text-zinc-500">scientific engineering</span>.
            </p>

            <div className="mt-10 md:mt-14 grid md:grid-cols-2 gap-8 md:gap-12">
              <p className="text-[15px] md:text-base leading-relaxed text-zinc-400 font-light">
                We are focused on developing flexible, mathematically grounded
                frameworks — not locked into a single product or vertical. Our
                work is shaped by long-term research questions and by the
                practical demands of turning ideas into reliable systems.
              </p>
              <p className="text-[15px] md:text-base leading-relaxed text-zinc-400 font-light">
                The company emerged from a graduate-level research trajectory
                and is structured to evolve alongside its technical foundations,
                supporting multiple applications and future directions as they
                mature.
              </p>
            </div>

            <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-8 border-t border-white/10 pt-10">
              {[
                { k: "Stage", v: "Early-Stage" },
                { k: "Model", v: "Research-Driven" },
                { k: "Region", v: "Canada" },
                { k: "Scope", v: "Foundational" },
              ].map((m) => (
                <div key={m.k}>
                  <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-zinc-500 mb-2">
                    {m.k}
                  </div>
                  <div className="font-heading text-xl md:text-2xl tracking-tight text-white font-medium">
                    {m.v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
